import React from "react";
import LibraryPdfItem from "@/react-components/LibraryPdfItem";
import TopScrollLink from "@/react-components/TopScrollLink";
import { api } from "@/utils/api";
import { isEmpty } from "@/utils";

class TaxBusinessSuccession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // categoryList: undefined,
      pdfInfos: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    // 税務・事業承継のカテゴリーを取得する
    // api.library
    //   .getPdfCategory({
    //     pagename: "taxation",
    //   })
    //   .then((res) => {
    //     this.setState({
    //         categoryList: res,
    //       });
    //   })
    //   .catch((error) => {
    //     console.error("error: " + error.message);
    //   });

    // 税務・事業承継のPDFを取得する
    api.library
      .getTaxaList()
      .then((res) => {
        this.setState({
          pdfInfos: res,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  scrollTo = (itemid) => {
    if (itemid) {
      let anchorElement = document.getElementById(itemid);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  };

  getList = () => {
    const { pdfInfos } = this.state;
    const newList = [];
    if (pdfInfos?.length > 0) {
      pdfInfos.sort(
        (a, b) => parseInt(a.category.sortNo) - parseInt(b.category.sortNo)
      );
      let itemid = "";
      let newSubList = [];
      for (const pdfInfo of pdfInfos) {
        if (isEmpty(pdfInfo.category.categoryName)) {
          continue;
        }
        if (itemid !== pdfInfo.category.itemid) {
          itemid = pdfInfo.category.itemid;
          let existedIndex = newList.map((item) => item.itemid).indexOf(itemid);
          if (existedIndex > -1) {
            newList[existedIndex].pdfList.push({
              id: pdfInfo.id,
              title: pdfInfo.title,
              updateDate: pdfInfo.updateDate,
              createDate: pdfInfo.createDate,
              pdfFile: pdfInfo.pdfFile,
            });
          } else {
            newSubList = [];
            newSubList.push({
              id: pdfInfo.id,
              title: pdfInfo.title,
              updateDate: pdfInfo.updateDate,
              createDate: pdfInfo.createDate,
              pdfFile: pdfInfo.pdfFile,
            });
            newList.push({
              itemid: itemid,
              sortNo: pdfInfo.category.sortNo,
              infoTitle: pdfInfo.category.categoryName,
              categoryName: pdfInfo.category.categoryName,
              pdfList: newSubList,
            });
          }
        } else {
          newSubList.push({
            id: pdfInfo.id,
            title: pdfInfo.title,
            updateDate: pdfInfo.updateDate,
            createDate: pdfInfo.createDate,
            pdfFile: pdfInfo.pdfFile,
          });
        }
      }
    }
    return newList;
  };

  render() {
    const newList = this.getList();
    return (
      <div className="library-container">
        <div className="summary-container summary-top-link-container">
          {newList && newList.length > 0
            ? newList.map((item, index) => (
                <TopScrollLink
                  key={index}
                  item={item}
                  scrollTo={() => this.scrollTo(item.itemid)}
                />
              ))
            : ""}
        </div>
        <div className="line-anchor-point"></div>
        <div className="library-container-area library-container-col-area">
          {newList && newList.length > 0
            ? newList.map((item, index) => (
                <div
                  id={item.itemid}
                  key={index}
                  className="library-container-info-area"
                >
                  <div className="library-container-info-title">
                    {item.infoTitle}
                  </div>
                  {item.pdfList && item.pdfList.length > 0
                    ? item.pdfList.map((subitem, subindex) => (
                        <LibraryPdfItem key={subindex} item={subitem} />
                      ))
                    : ""}
                </div>
              ))
            : ""}
        </div>
      </div>
    );
  }
}

export default TaxBusinessSuccession;
